// 设备管理越南文文案
const vn = {
  categoryManagement: "Quản lý danh mục thiết bị",
  addOrEditEquipmentCategory: "Thêm/Sửa danh mục thiết bị",
  addOrEditEquipmentInfo: "Thêm/Sửa thông tin thiết bị",
  addRootCategory: "Thêm danh mục chính",
  addSubCategory: "Thêm danh mục con",
  batchSubCategories: "Danh mục con",
  addBatchSubCategory: "Thêm danh mục con",
  removeSubCategory: "Xóa danh mục con",
  subCategoryItem: "Danh mục con {{index}}",
  editCategory: "Sửa danh mục",
  disableCategory: "Vô hiệu hóa danh mục",
  enableCategory: "Kích hoạt danh mục",
  categoryCode: "Mã danh mục",
  categoryName: "Tên danh mục",
  categoryDesc: "Mô tả danh mục",
  sortOrder: "Thứ tự sắp xếp",
  level: "Cấp",
  enabled: "Đã kích hoạt",
  disabled: "Đã vô hiệu hóa",
  selectCategoryPlaceholder: "Chọn danh mục thiết bị",
  noCategoryData: "Không có danh mục thiết bị",
  categoryCodeRequired: "Nhập mã danh mục",
  categoryNameRequired: "Nhập tên danh mục",
  confirmDisableCategory: "Vô hiệu hóa cũng sẽ vô hiệu hóa tất cả danh mục con. Tiếp tục?",
  confirmEnableCategory: "Kích hoạt cũng sẽ kích hoạt tất cả danh mục cha. Tiếp tục?",
  categoryFetchFailed: "Thao tác danh mục thiết bị thất bại",
  categoryOperationSucceeded: "Thao tác danh mục thiết bị thành công",
  equipmentLedger: "Danh sách thiết bị",
  myBorrowed: "Thiết bị tôi mượn",
  maintainUpcoming: "Đến hạn bảo dưỡng",
  maintainUpcomingQuery: "Tra cứu đến hạn bảo dưỡng",
  equipmentList: "Danh sách thiết bị",
  addEquipment: "Thêm thiết bị",
  editEquipment: "Sửa thiết bị",
  equipmentDetail: "Chi tiết thiết bị",
  equipmentCategory: "Danh mục thiết bị",
  equipmentNumber: "Mã thiết bị",
  equipmentName: "Tên thiết bị",
  equipmentKeywordPlaceholder: "Nhập từ khóa thiết bị",
  equipmentStatus: "Trạng thái thiết bị",
  brand: "Thương hiệu",
  model: "Mẫu",
  serialNo: "Số sê-ri",
  qrCode: "Mã QR",
  disableEquipment: "Vô hiệu hóa",
  enableEquipment: "Kích hoạt",
  maintenanceRecord: "Bảo trì",
  borrowEquipment: "Mượn",
  returnEquipment: "Trả",
  recordFlow: "Nhật ký hoạt động",
  recordDetail: "Chi tiết bản ghi",
  operator: "Người thao tác",
  borrower: "Người mượn",
  returnAt: "Thời gian trả thực tế",
  confirmDisableEquipment: "Vô hiệu hóa thiết bị này?",
  confirmEnableEquipment: "Kích hoạt thiết bị này?",
  equipmentStateUpdated: "Đã cập nhật trạng thái thiết bị",
  equipmentStateUpdateFailed: "Không thể cập nhật trạng thái thiết bị",
  qrCodeFetchFailed: "Không thể tải mã QR",
  noQrCodeData: "Không có dữ liệu mã QR",
  addMaintenanceRecord: "Thêm bản ghi bảo trì",
  recordType: "Loại bản ghi",
  recordTypeRequired: "Chọn loại bản ghi",
  occurredAt: "Thời gian phát sinh",
  occurredAtRequired: "Chọn thời gian phát sinh",
  expectedReturnAt: "Thời gian trả dự kiến",
  scrapEquipment: "Thanh lý",
  confirmScrapEquipment: "Không thể khôi phục thiết bị sau khi thanh lý. Tiếp tục?",
  recordCost: "Chi phí",
  recordCostCurrency: "Tiền tệ",
  odometer: "Mức sử dụng",
  vendor: "Nhà cung cấp dịch vụ",
  recordComment: "Ghi chú",
  recordTypesFetchFailed: "Không thể tải loại bản ghi",
  recordListFetchFailed: "Không thể tải lịch sử bản ghi",
  recordFetchFailed: "Không thể tải chi tiết bản ghi",
  noRecordDetail: "Không có chi tiết bản ghi",
  addRecordSucceeded: "Đã thêm bản ghi bảo trì",
  addRecordFailed: "Không thể thêm bản ghi bảo trì",
  keeperOrg: "Bộ phận bảo quản",
  ownedOrg: "Bộ phận mua/sở hữu",
  currentUser: "Người dùng hiện tại",
  location: "Vị trí",
  placeLocation: "Nơi đặt",
  editPlaceLocation: "Sửa nơi đặt",
  placeLocationUpdateSucceeded: "Đã cập nhật nơi đặt",
  placeLocationUpdateFailed: "Không thể cập nhật nơi đặt",
  maintainDays: "Chu kỳ bảo dưỡng (ngày)",
  maintainThreshold: "Chu kỳ bảo dưỡng (mức sử dụng)",
  dueByDays: "Theo số ngày",
  dueByThreshold: "Theo mức sử dụng",
  due: "Đã đến hạn",
  notDue: "Chưa đến hạn",
  remainDays: "Số ngày còn lại",
  remainThreshold: "Mức sử dụng còn lại",
  lastMaintainAt: "Lần bảo dưỡng gần nhất",
  lastMaintainOdometer: "Mức sử dụng lần trước",
  currentOdometer: "Mức sử dụng hiện tại",
  purchaseInfo: "Thông tin mua sắm",
  purchaseAt: "Ngày mua",
  purchasePrice: "Giá mua",
  purchaseCurrency: "Tiền tệ mua",
  supplier: "Nhà cung cấp",
  createdBy: "Người tạo",
  createdAt: "Thời gian tạo",
  updatedBy: "Người cập nhật",
  updatedAt: "Thời gian cập nhật",
  actions: "Thao tác",
  equipmentNameRequired: "Nhập tên thiết bị",
  keeperOrgRequired: "Chọn bộ phận bảo quản",
  rootCategoryCannotAdd: "Không thể thêm thiết bị vào danh mục gốc. Hãy chọn danh mục con",
  addEquipmentSucceeded: "Đã thêm thiết bị",
  editEquipmentSucceeded: "Đã cập nhật thiết bị",
  equipmentSaveFailed: "Không thể lưu thiết bị",
  equipmentFetchFailed: "Không thể tải chi tiết thiết bị",
  equipmentListFetchFailed: "Không thể tải danh sách thiết bị",
  myBorrowedFetchFailed: "Không thể tải thiết bị đã mượn",
  upcomingMaintainFetchFailed: "Không thể tải thiết bị đến hạn bảo dưỡng",
  equipmentStatusFetchFailed: "Không thể tải trạng thái thiết bị",
  noEquipmentDetail: "Không có chi tiết thiết bị",
};

export default vn;
